import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { createRequestTypes, EDIT_GENERAL_INFO_ACTION } from '~/actions';
import { useAppSelector } from '~/hooks/useAppSelector';
import { apiMethodsConst } from '~/services/methods';
import { UpdateUserService } from '../services/UpdateUserService';
import type { IUpdateUserRequest } from '../types/UpdateUser';

const GENERIC_ERROR_MESSAGE = 'Something went wrong, please try again.';

const editUserEvents = createRequestTypes(EDIT_GENERAL_INFO_ACTION) as {
  REQUEST: string;
  SUCCESS: string;
  FAILURE: string;
};

export const useUpdateUser = () => {
  const dispatch = useDispatch();
  const currentUser = useAppSelector((state) => state.user?.user ?? null);

  return useMutation<void, unknown, IUpdateUserRequest>({
    mutationFn: (payload) => UpdateUserService.updateUser(payload),
    onSuccess: (_data, variables) => {
      if (!currentUser?.id) return;
      dispatch({
        type: apiMethodsConst.EDIT_USER_REQUEST,
        payload: {
          ...currentUser,
          first_name: variables.firstName,
          last_name: variables.lastName,
        },
      });
    },
    onError: (error) => {
      const message = error instanceof Error ? error.message : GENERIC_ERROR_MESSAGE;
      dispatch({
        type: editUserEvents.FAILURE,
        payload: { message },
      });
    },
  });
};
